import { ref } from 'vue'

export const messageCenterUnread = ref(0)

export function setMessageCenterUnread(count: number) {
  messageCenterUnread.value = Math.max(0, count)
}
